// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"af91c9a7","395":"8f540a15","530":"59cec216","549":"d83a24a1","567":"3eaf575a","696":"9250d2d4","756":"0fb2d752"}[chunkId] + ".chunk.css";
};